import { createApiHandler } from './handler';

const pets = {
  apiClient: null,
  path: '/franchises/pets',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getByBranch(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/branch/${id}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCheckups(id, params) {
    try {
      const queryParams = new URLSearchParams();
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/${id}/checkups?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCheckupById(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/checkups/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckup(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/checkups`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCheckup(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/checkups/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckup(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckupImage(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/checkups/${id}/image`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckupImage(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/image/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createCheckupFile(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/checkups/${id}/file`, form, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteCheckupFile(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/checkups/file/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCommentById(id) {
    try {
      const response = await this.apiClient.get(`${this.path}/comments/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async createComment(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/comments`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateComment(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/comments/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async deleteComment(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/comments/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export default pets;
